<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import { useAccountFeatures } from 'dashboard/composables/useAccountFeatures';

import PageLayout from 'dashboard/components-next/pilot/PageLayout.vue';
import BuiltinToolCard from 'dashboard/components-next/pilot/pageComponents/builtinTool/BuiltinToolCard.vue';
import FeatureSpotlightPopover from 'dashboard/components-next/feature-spotlight/FeatureSpotlightPopover.vue';
import PilotBuiltinToolsAPI from 'dashboard/api/pilot/builtinTools';

const router = useRouter();
const store = useStore();
const { hasMarketingCloudTenantId } = useAccountFeatures();

const builtinTools = ref([]);
const isLoading = ref(true);

// 过滤：营销云版本不显示"更新联系人"工具
const filteredTools = computed(() => {
  return builtinTools.value.filter(tool => {
    if (tool.id === 'update_contact' && hasMarketingCloudTenantId.value) {
      return false;
    }
    return true;
  });
});

const handleConfigure = tool => {
  if (tool.config_route) {
    router.push({ name: tool.config_route });
  }
};

const loadTools = async () => {
  try {
    const { data } = await PilotBuiltinToolsAPI.getTools();
    builtinTools.value = data;
  } catch (error) {
    console.error('Failed to load builtin tools:', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  loadTools();
  store.dispatch('pilotAssistants/get');
});
</script>

<template>
  <PageLayout
    :header-title="$t('PILOT.BUILTIN_TOOLS.HEADER')"
    :show-pagination-footer="false"
    :is-empty="false"
    :show-know-more="true"
    :show-assistant-switcher="false"
  >
    <template #knowMore>
      <FeatureSpotlightPopover
        :button-label="$t('PILOT.HEADER_KNOW_MORE')"
        :title="$t('PILOT.BUILTIN_TOOLS.FEATURE_SPOTLIGHT.TITLE')"
        :note="$t('PILOT.BUILTIN_TOOLS.FEATURE_SPOTLIGHT.NOTE')"
        fallback-thumbnail="/assets/images/dashboard/pilot/tools-popover-light.svg"
        fallback-thumbnail-dark="/assets/images/dashboard/pilot/tools-popover-dark.svg"
      />
    </template>
    <template #body>
      <div class="flex flex-col gap-4">
        <BuiltinToolCard
          v-for="tool in filteredTools"
          :id="tool.id"
          :key="tool.id"
          :title="tool.title"
          :description="tool.description"
          :icon="tool.icon"
          :logo="tool.logo"
          :has-config="!!tool.config_route"
          @configure="handleConfigure(tool)"
        />
      </div>
    </template>
  </PageLayout>
</template>
